import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, Popover } from '@treams/treams-ui';

import RecipientSelector from '../../../packages/kakapo-ui-kit/components/recipients/RecipientSelector';
import { Recipient } from '../../../packages/kakapo-ui-services/models/Recipient';

type Props = {
	recipients: Recipient[];
	onAddRecipients: (recipients: Recipient[]) => void;
	onCancel: () => void;
};

export function FeedbackAddRecipientsModal({ recipients, onAddRecipients, onCancel }: Props) {
	const { t } = useTranslation();
	const [newRecipients, setNewRecipients] = useState<Recipient[]>([]);

	return (
		<Popover visible center>
			<Modal>
				<Modal.Header title={t('common.feedback.addRecipients')} />

				<Modal.Contents>
					<RecipientSelector
						initialRecipients={newRecipients}
						excludeRecipients={recipients}
						onChange={setNewRecipients}
						footer={null}
					/>
				</Modal.Contents>
				<Modal.FormFooter
					onCancel={onCancel}
					disabled={newRecipients.length === 0}
					saveTitle={t('common.feedback.nextStepSend')}
					onSave={() => onAddRecipients(newRecipients)}
				/>
			</Modal>
		</Popover>
	);
}
